import * as React from 'react';
import { Input, Toggle, Tooltip } from 'vet-bones/design-system/components';

import { TEST_IDS } from 'src/constants/testIds';
import {
  ProjectFileUploadOptions,
  defaultProjectFileUploadOptions,
} from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

import styles from 'src/components/resourceDialog/styles/projectResourceOptionsForm.module.scss';

type ProjectFileUploadOptionsFormProps = {
  fileOptions: ProjectFileUploadOptions;
  disableEditing?: boolean;
  disableHeaderToggle?: boolean;
  onSetFileOptions: (fileOptions: ProjectFileUploadOptions) => void;
};

export const ProjectFileUploadOptionsForm: React.VFC<
  ProjectFileUploadOptionsFormProps
> = ({
  fileOptions,
  disableEditing,
  disableHeaderToggle,
  onSetFileOptions,
}) => (
  <div className={styles.projectResourceOptionsForm}>
    <Input
      clearable={false}
      disabled={disableEditing}
      id="sd-project-file-upload-options-separator"
      invalid={!fileOptions.separator}
      label={
        copy.components.projectResourceDialog.projectFileUploadPanel.form
          .separator
      }
      name="separator"
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
        onSetFileOptions({
          ...fileOptions,
          separator: evt.target.value,
        });
      }}
      placeholder={defaultProjectFileUploadOptions.separator}
      size="md"
      testId={TEST_IDS.projectFileUploadPanel.form.separator}
      value={fileOptions.separator}
    />
    <Input
      clearable={false}
      disabled={disableEditing}
      id="sd-project-file-upload-options-quote"
      invalid={!fileOptions.quote}
      label={
        copy.components.projectResourceDialog.projectFileUploadPanel.form.quote
      }
      name="quote"
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
        onSetFileOptions({
          ...fileOptions,
          quote: evt.target.value,
        });
      }}
      placeholder={defaultProjectFileUploadOptions.quote}
      size="md"
      testId={TEST_IDS.projectFileUploadPanel.form.quote}
      value={fileOptions.quote}
    />
    <Input
      clearable={false}
      disabled={disableEditing}
      id="sd-project-file-upload-options-escape"
      invalid={!fileOptions.escape}
      label={
        copy.components.projectResourceDialog.projectFileUploadPanel.form.escape
      }
      name="escape"
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
        onSetFileOptions({
          ...fileOptions,
          escape: evt.target.value,
        });
      }}
      placeholder={defaultProjectFileUploadOptions.escape}
      size="md"
      testId={TEST_IDS.projectFileUploadPanel.form.escape}
      value={fileOptions.escape}
    />
    <div className={styles.toggleField}>
      <Tooltip
        description={
          copy.components.projectResourceDialog.projectFileUploadPanel.form
            .duplicateHeaders
        }
        disabled={disableEditing || !disableHeaderToggle}
      >
        <Toggle
          checked={fileOptions.header}
          disabled={disableEditing || disableHeaderToggle}
          id="sd-project-file-upload-options-header"
          name="header"
          onChange={() => {
            onSetFileOptions({
              ...fileOptions,
              header: !fileOptions.header,
            });
          }}
          size="md"
        />
      </Tooltip>
      <label
        className={styles.toggleLabel}
        htmlFor="sd-project-file-upload-options-header"
      >
        {
          copy.components.projectResourceDialog.projectFileUploadPanel.form
            .header
        }
      </label>
    </div>
    <div className={styles.toggleField}>
      <Toggle
        checked={fileOptions.skipEmpty}
        disabled={disableEditing}
        id="sd-project-file-upload-options-skip-empty"
        name="skipEmpty"
        onChange={() => {
          onSetFileOptions({
            ...fileOptions,
            skipEmpty: !fileOptions.skipEmpty,
          });
        }}
        size="md"
      />
      <label
        className={styles.toggleLabel}
        htmlFor="sd-project-file-upload-options-skip-empty"
      >
        {
          copy.components.projectResourceDialog.projectFileUploadPanel.form
            .skipEmpty
        }
      </label>
    </div>
  </div>
);
